module.exports = __webpack_public_path__ + "img/naotu_4.fac51fb0.png";